"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const styles_1 = require("../styles");
const Image = ({ variant = 'default', source, defaultSource, style, onError, ...props }) => {
    const [imageSource, setImageSource] = react_1.useState(() => {
        if (typeof source === 'object' && !Array.isArray(source) && !source.uri && defaultSource)
            return defaultSource;
        return source;
    });
    return (react_1.default.createElement(react_native_1.View, { style: [styles.container, variant === 'outlined' && styles.outlined, style] },
        react_1.default.createElement(react_native_1.Image, Object.assign({ source: imageSource, defaultSource: defaultSource, onError: (e) => {
                if (defaultSource)
                    setImageSource(defaultSource);
                onError?.(e);
            }, style: styles.flex }, props))));
};
exports.default = Image;
const styles = react_native_1.StyleSheet.create({
    container: {
        borderRadius: styles_1.getRadius(),
        overflow: 'hidden',
    },
    outlined: {
        borderWidth: styles_1.getSpacing('border'),
        borderColor: styles_1.Colors.background,
    },
    flex: {
        height: '100%',
        width: '100%',
    },
});
